__turbopack_context__.v({
  "learnMoreLink": "HomepageCarrierList-module-scss-module__EQ7MvG__learnMoreLink",
  "modalBody": "HomepageCarrierList-module-scss-module__EQ7MvG__modalBody",
  "modalTitle": "HomepageCarrierList-module-scss-module__EQ7MvG__modalTitle",
  "phoneText": "HomepageCarrierList-module-scss-module__EQ7MvG__phoneText",
});
